import { render } from "./SingleMilanMatchResult.vue?vue&type=template&id=2e2d4f51&scoped=true"
import script from "./SingleMilanMatchResult.vue?vue&type=script&lang=js"
export * from "./SingleMilanMatchResult.vue?vue&type=script&lang=js"

import "./SingleMilanMatchResult.vue?vue&type=style&index=0&id=2e2d4f51&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e2d4f51"]])

export default __exports__